import BehaviorActionTypes from '../../constants/behavior_action_types';
import BehaviorExpressionParser from '../expression/behavior_expression_parser';
import { getFormElementAPI } from '../../utils/form_element_api_builder';
import CancelEventException from 'events/cancel_event_exception';
import { changeDecimalString } from 'utils/formatting_utils';
import { FormEvents } from '../../../form/events/form_event_handler';

export const execute = (formAPI, behavior, eventName, isIfAction) => {
	let actions = isIfAction ? behavior.actions : behavior.elseActions;

	executeSetPropertyActions(formAPI, actions);
	executeOtherBehaviorActions(formAPI, actions);
};

const executeSetPropertyActions = (formAPI, actions) => {
	const setPropertyActions = actions.filter(action => action.type === BehaviorActionTypes.SET_PROPERTY);	

	if (setPropertyActions.length <= 0) return;

	let changed = false;
	for (let cont = 0, len = setPropertyActions.length; cont < len; cont++) {
		let grid = setPropertyActions[cont];

		if (grid.gridId !== undefined && grid.property !== 'value') {
			if (setPropertyActions[cont].property === "addOptions" || setPropertyActions[cont].property === "removeOptions" || setPropertyActions[cont].property === "clear") {
				let actionFormElementAPI = getFormElementAPI(formAPI, setPropertyActions[cont]);

				if (actionFormElementAPI.type() === "AUTOCOMPLETE" || actionFormElementAPI.type() === "RADIO") {
					if (actionFormElementAPI.optionsUrl()) {
						actionFormElementAPI.subscribe(FormEvents.LOAD_OPTIONS_SUCCESS, () => {
							executeList(actionFormElementAPI, setPropertyActions, setPropertyActions[cont]);
						});
					} else {
						executeList(actionFormElementAPI, setPropertyActions, setPropertyActions[cont]);
					}
				}
			} else {
				//Utilizado setTimeOut por não ter o tempo de carregamento do formulário corretamente
				setTimeout(() => {
					if (!changed) {
						changed = executeSetPropertyAction(formAPI, setPropertyActions[cont]);
					} else {
						executeSetPropertyAction(formAPI, setPropertyActions[cont]);
					}
				}, 500);
			}
		} else {
			if (setPropertyActions[cont].property === "addOptions" || setPropertyActions[cont].property === "removeOptions" || setPropertyActions[cont].property === "clear") {
				let actionFormElementAPI2 = getFormElementAPI(formAPI, setPropertyActions[cont]);

				if (actionFormElementAPI2.type() === "AUTOCOMPLETE" || actionFormElementAPI2.type() === "RADIO") {
					if (actionFormElementAPI2.optionsUrl()) {
						actionFormElementAPI2.subscribe(FormEvents.LOAD_OPTIONS_SUCCESS, () => {
							executeList(actionFormElementAPI2, setPropertyActions, setPropertyActions[cont]);
						});
					} else {
						executeList(actionFormElementAPI2, setPropertyActions, setPropertyActions[cont]);
					}
				}
			} else {
				setTimeout(() => {
					if (!changed) {
						setTimeout(()=>{
							changed = executeSetPropertyAction(formAPI, setPropertyActions[cont]);
						}, 0)
					}
					else {
						setTimeout(()=>{
							executeSetPropertyAction(formAPI, setPropertyActions[cont]);
						}, 0)
					}
				}, 0)
			}
		}
	}

	//removendo para poder reexecutar a regra de tela caso precise
	if (window['screenrule']) {
		delete window['screenrule'];
	}

	setTimeout(() => {
		if (changed) {
			formAPI.apply();
		}
	},550);

	if (changed) {
		setTimeout(() => {
			formAPI.apply();
		},0);
	}
	
};

const executeList = (field, actions, currentAction) => {
	//para executar uma unica vez a regra de tela
	if (!window['screenrule']) {
		window['screenrule'] = {};
	}

	if (!window['screenrule'][field.id]) {
		window['screenrule'][field.id] = true;

		if (actions && actions.length > 0) {
			setTimeout(() => {

				let oldOptions = field.options() ? [...field.options()] : [];

				actions.forEach((item) => {
					if (item.fieldId === field.id) {
						if (item.property === "addOptions") {
							let opt = oldOptions.filter((obj) => obj.name.toLowerCase() === item.value.value.toLowerCase());
							if (opt && opt.length === 0) {
								oldOptions.push({value: item.value.value, name: item.value.value});
							}
						}

						if (item.property === "removeOptions") {

							oldOptions = oldOptions.filter((opt, id) => {
								if(opt.value.toLowerCase() !== item.value.value.toLowerCase()) {
									return opt
								}
							})
						}

						if (item.property === "clear") {
							oldOptions = [];
						}
					}
				});

				setTimeout(() => {
					field.removeOptions([]).apply();

					setTimeout(() => {
						field.addOptions(oldOptions).apply();
					}, 100)
				}, 0)
			}, 0);
		}
	}
}

const executeOtherBehaviorActions = (formAPI, actions) => {
	actions
		.filter(a => a.type !== BehaviorActionTypes.SET_PROPERTY)
		.forEach(executeBehaviorAction.bind(this, formAPI));
};

const executeBehaviorAction = (formAPI, action) => {
	switch (action.type) {
		case BehaviorActionTypes.SCRIPT:
			executeScriptAction(formAPI, action);
		break;

		case BehaviorActionTypes.CANCEL_EVENT:
			executeCancelEventAction(formAPI, action);
		break;

		default:
			break;
	}
};

const mapperSetPropertyGroups = (property) => {
	const objMapper = {
		"label": "name",
		"hidden": "visible",
		"visible" : "visible",
		"expand": "expanded",
		"contract": "expanded",
		"collapse": "expansible"
	};

	return objMapper[property];
}

const executeSetPropertyAction = (formAPI, action) => {
	const { property, value } = action;

	const actionFormElementAPI = getFormElementAPI(formAPI, action);
	const destiny = value !== undefined && value !== null ? formAPI.fields(value.fieldId) : "";
	let parsedValue = "";

	if (typeof value === "undefined") {
		actionFormElementAPI[property]();
		return;
	}

	if (action.element === 'GROUP') {
		let groupId = action.groupId;
		setTimeout(() => {
			formAPI.groups(groupId)[mapperSetPropertyGroups(action.property)](action.value.value).apply();
		}, 0);
	}

	if (action.value.fieldId !== undefined && action.gridId === undefined) {
		if (action.value.gridId) {
			let fieldGrid = action !== undefined && action !== null ? formAPI.fields(action.value.gridId).fields(action.value.fieldId) : "";
			let valueField = fieldGrid.value() ? fieldGrid.value() : ' ';
			formAPI.fields(action.fieldId).value(valueField).apply();
		}

		if ((actionFormElementAPI.type() === 'TEXT' || actionFormElementAPI.type() === 'TEXTAREA' ) && destiny && destiny.type() === 'DATE'){
			parsedValue = destiny.value();
		} else if ((actionFormElementAPI.type() === 'TEXT' || actionFormElementAPI.type() === 'TEXTAREA' ) && destiny && destiny.type() === 'CURRENCY' || actionFormElementAPI.type() === 'CURRENCY' && (destiny.type() === 'TEXTAREA' || destiny.type() === 'TEXT')) {
			let valueFormatted = destiny.value() !== null && destiny.value() !== undefined ?  destiny.value() : "";

			if (!!valueFormatted && destiny.type() === "CURRENCY") {
				const maxLength = destiny.maxLength();
				const digits = destiny.digits();
				const component = destiny.component();
				const prefix = destiny.prefix();
				valueFormatted = changeDecimalString(valueFormatted, maxLength, digits, component, prefix, true);
			}

			parsedValue = valueFormatted;
		} else if ((actionFormElementAPI.type() === 'TEXT' || actionFormElementAPI.type() === 'TEXTAREA' ) && destiny && destiny.type() === 'DECIMAL' || actionFormElementAPI.type() === 'DECIMAL' && (destiny.type() === 'TEXTAREA' || destiny.type() === 'TEXT')) {
			let valueFormatted = destiny.value() !== null && destiny.value() !== undefined ?  destiny.value() : "";

			if (!!valueFormatted && destiny.type() === "DECIMAL") {
				const maxLength = destiny.maxLength();
				const digits = destiny.digits();
				const component = destiny.component();
				const prefix = destiny.prefix();
				valueFormatted = changeDecimalString(valueFormatted, maxLength, digits, component, prefix, true);
			}

			parsedValue = valueFormatted;
		} else {
			parsedValue = BehaviorExpressionParser.parse(formAPI, value);
		}
	} else if (action.fieldId !== undefined  && action.gridId !== undefined && action.property === 'value') {
		let actionFieldId = action.fieldId;
		let destinyGrid = action !== undefined && action !== null ? formAPI.fields(action.gridId).fields(actionFieldId) : "";

		if ((actionFormElementAPI.type() === 'TEXT' || actionFormElementAPI.type() === 'TEXTAREA' )&& destinyGrid.type() === 'DATE') {
			parsedValue = destinyGrid.value();
		} else if ((actionFormElementAPI.type() === 'TEXT' || actionFormElementAPI.type() === 'TEXTAREA') && destinyGrid.type() === 'CURRENCY' || actionFormElementAPI.type() === 'CURRENCY' && (destinyGrid.type() === 'TEXTAREA' || destinyGrid.type() === 'TEXT')) {
			let valueFormatted = destinyGrid.value() !== null && destinyGrid.value() !== undefined ?  destinyGrid.value() : "";

			if (!!valueFormatted && destinyGrid.type() === "CURRENCY") {
				const maxLength = destinyGrid.maxLength();
				const digits = destinyGrid.digits();
				const component = destinyGrid.component();
				const prefix = destinyGrid.prefix();
				valueFormatted = changeDecimalString(valueFormatted, maxLength, digits, component, prefix, true);
			}

			parsedValue = valueFormatted;
		} else if ((actionFormElementAPI.type() === 'TEXT' || actionFormElementAPI.type() === 'TEXTAREA' )&& destinyGrid.type() === 'DECIMAL' || actionFormElementAPI.type() === 'DECIMAL' && (destinyGrid.type() === 'TEXTAREA' || destinyGrid.type() === 'TEXT')) {
			let valueFormatted = destinyGrid.value() !== null && destinyGrid.value() !== undefined ?  destinyGrid.value() : "";

			if (!!valueFormatted && destinyGrid.type() === "DECIMAL") {
				const maxLength = destinyGrid.maxLength();
				const digits = destinyGrid.digits();
				const component = destinyGrid.component();
				const prefix = destinyGrid.prefix();
				valueFormatted = changeDecimalString(valueFormatted, maxLength, digits, component, prefix, true);
			}
			parsedValue = valueFormatted;
		} else {
			if ((action.value !== undefined || action.value !== null) && action.value.type === "VALUE") {
				let fieldId = action.fieldId;
				let value = action.value.value;

				if (typeof value === 'boolean') {
					parsedValue = BehaviorExpressionParser.parse(formAPI, value);
				} else {
					setTimeout(() => {
						if (actionFormElementAPI.type() === 'DECIMAL' || actionFormElementAPI.type() === 'CURRENCY') {
							if (typeof parsedValue === 'string') {
								parsedValue = destinyGrid.value(value.replace(",","."));
								destinyGrid.value(value.replace(",",".")).apply();
							}
						} else {
							parsedValue = destinyGrid.value(value);
							destinyGrid.value(value).apply();
						}
					}, 0)
				}
			}

			setTimeout(() => {
				parsedValue = BehaviorExpressionParser.parse(formAPI, value);
			}, 0);
		}
	} else {
		parsedValue = BehaviorExpressionParser.parse(formAPI, value);
	}

	if (action.element !== 'GROUP') {
		if (action.element !== 'FORM' && (actionFormElementAPI.type() === 'AUTOCOMPLETE' || actionFormElementAPI.type() === 'RADIO')) {
			setTimeout(() => {
				actionFormElementAPI[property](parsedValue).apply();
			}, 0);
		} else {
			if (action.element !== 'FORM' && (actionFormElementAPI.type() === 'DECIMAL' || actionFormElementAPI.type() === 'CURRENCY')) {
				if (typeof parsedValue === 'string') {
					setTimeout(() => {
						parsedValue = parsedValue.replace(",",".");
					}, 0);
				}
			}

			setTimeout(() => {
				actionFormElementAPI[property](parsedValue).apply();
			}, 0);
		}

		return true;
	} else {
		if (action.element !== 'FORM' && actionFormElementAPI && actionFormElementAPI.type() !== "GRID") {
			actionFormElementAPI[property](parsedValue).apply();
		}
	}		

	return false;
};

const hasChangeValueField = (valueField, parsedValue) => typeof parsedValue === 'object' ? true : valueField !== parsedValue;

const executeScriptAction = (formAPI, action) => {
	const { script } = action;
	const scriptFunction = new Function(script);
	scriptFunction(formAPI);
};

const executeCancelEventAction = (formAPI, action) => {
	const { reason } = action;
	throw new CancelEventException(reason);
};

export default {
	execute,
};
